import { Wrap } from '@chakra-ui/react';
import { ProfileFeatureItem } from './components/ProfileFeatureItem';

interface ProfileFeaturesProps {
  items: ProfileFeatureItem[];
  variant?: 'full' | 'bullet-separated' | 'comma-separated';
}

export const ProfileFeatures = ({
  items,
  variant = 'full',
}: ProfileFeaturesProps) => {
  const visibleItems = items.filter(item => item.show);

  return (
    <Wrap
      spacingX={variant === 'full' ? 5 : 1}
      spacingY={{
        mobile: '1',
        desktop: variant === 'full' ? '2' : '0',
      }}
    >
      {visibleItems.map((item, index) => (
        <ProfileFeatureItem
          key={index}
          item={item}
          variant={variant}
          isLastInList={index === visibleItems.length - 1}
        />
      ))}
    </Wrap>
  );
};
